import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/basic-health/lab-procedures/gpt";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	gpt: {
		id: "form.gpt",
		defaultMessage: "GPT"
	},
	value: {
		id: "form.gpt.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "bh_gpt",
	value: {
		schemaId: "gpt",
		title: messages.gpt,
		validator,
		fieldset,
		isImportant: true
	}
};
